import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";

// Define a service using a base URL and expected endpoints
export const scheduleApi = createApi({
  reducerPath: "scheduleApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Schedules", "Slots"],
  endpoints: (builder) => ({
    getScheduleList: builder.query({
      query: (subdomain) => {
        return {
          url: `/schedule/list`,
          method: "GET",
          params: { subdomain: subdomain },
        };
      },
      providesTags: (result) => {
        return result
          ? [
              ...result.map(({ id }) => ({ type: "Schedules", id })),
              { type: "Schedules", id: "LIST" },
            ]
          : [{ type: "Schedules", id: "LIST" }];
      },
    }),
    getScheduleSlotsByDate: builder.query({
      query: ({subdomain, date, id}) => {
        if(date.length > 1 && date[1] !== null)
          return {
            url: `/schedule/${id}/slots`,
            method: "GET",
            params: { subdomain: subdomain, start: date[0], end: date[1] },
          }
        else {
          return {
            url: `/schedule/${id}/slots`,
            method: "GET",
            params: { subdomain: subdomain, date: date },
          }
        }
      },
      providesTags: (result) => {
        return result
          ? [
            ...result.map(({ id }) => ({ type: "Slots", id })),
            { type: "Slots", id: "LIST" },
          ]
          : [{ type: "Slots", id: "LIST" }];
      },
    }),
    createSchedule: builder.mutation({
      query: (payload) => {
        return {
          url: `/schedule/create`,
          method: "POST",
          body: { ...payload },
        };
      },
      invalidatesTags: [{ type: "Schedules", id: "LIST" }],
    }),
    updateSchedule: builder.mutation({
      query: ({ id, payload, subDomain }) => {
        return {
          url: `/schedule/${id}`,
          method: "PATCH",
          body: { ...payload },
          params: { subdomain: subDomain },
        };
      },
      invalidatesTags: [{ type: "Schedules", id: "LIST" }],
    }),
    deleteSchedule: builder.mutation({
      query: ({ id, subDomain }) => {
        return {
          url: `/schedule/${id}`,
          method: "DELETE",
          params: { subdomain: subDomain },
        };
      },
      invalidatesTags: [{ type: "Schedules", id: "LIST" }],
    }),
  }),
});

export const {
  useGetScheduleListQuery,
  useGetScheduleSlotsByDateQuery,
  useLazyGetScheduleSlotsByDateQuery,
  useCreateScheduleMutation,
  useUpdateScheduleMutation,
  useDeleteScheduleMutation,
} = scheduleApi;
